import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Environment, EnvironmentConfigService, IftaServiceName } from '../environment';
import * as i0 from "@angular/core";
import * as i1 from "../../../../model/src/lib/environment.token";
import * as i2 from "@angular/common/http";
import * as i3 from "../environment/environment-config.service";
export class IftaConstantsService {
    constructor(environment, http, environmentConfigService) {
        this.environment = environment;
        this.http = http;
        this.environmentConfigService = environmentConfigService;
        this._serviceUrl = null;
        this._serviceUrl =
            this.environmentConfigService.getEnvironmentConfigs().apis.ifta.url +
                '/' +
                this.environment.serviceUrlList[IftaServiceName.IftaConstantsService];
    }
    getQuarters() {
        return this.http.get(`${this._serviceUrl}/quarters`);
    }
    getCurrentQuarter() {
        return this.getQuarters().pipe(map(quarters => quarters[quarters.length - 1]));
    }
    getDatesforQuarter(quarter) {
        const params = new HttpParams().set('quarter', quarter);
        return this.http.get(`${this._serviceUrl}/dates`, { params });
    }
}
IftaConstantsService.ngInjectableDef = i0.defineInjectable({ factory: function IftaConstantsService_Factory() { return new IftaConstantsService(i0.inject(i1.ENVIRONMENT), i0.inject(i2.HttpClient), i0.inject(i3.EnvironmentConfigService)); }, token: IftaConstantsService, providedIn: "root" });
